<template>
  <Modal ref="modal" title="Pendentes e Rejeitadas" @cancel="close">
    <div class="loading" v-if="!loaded">
      <LoadingSpinner />
    </div>

    <template v-else>
      <div class="actions">
        <Button @handle:click="handleExport" text="Gerar planilha" color="primary" :disabled="loading" 
          data-testid="btn-gerar-planilha">
          <TrayArrowDown :size="18" />
        </Button>
      </div>

      <form class="relatorio-form" @submit.prevent="handleSubmit" data-testid="form-pendentes-rejeitadas">
        <div class="inputs">
          <div class="inputs-row">
            <Select class="input-full" :options="schemaOptions" legend="Autoescola" placeholder="Selecione"
              :modelValue="schema" @update:modelValue="$event => (this.schema = $event)" :disabled="loading" 
              data-testid="select-autoescola" />

            <Period legend="Insira o período" :firstModelValue="initialDate" :secondModelValue="finalDate"
              @update:firstModelValue="$event => (this.initialDate = $event)"
              @update:secondModelValue="$event => (this.finalDate = $event)" :disabled="loading" 
              data-testid="period-filter" />
          </div>
          <div class="inputs-row">
            <Input class="input-full" :modelValue="aluno" @update:modelValue="$event => (this.aluno = $event)"
              legend="Aluno(a)" placeholder="Digite o nome do aluno(a)" :disabled="loading" 
              data-testid="input-aluno" />

            <Input class="input-full" :modelValue="instrutor" @update:modelValue="$event => (this.instrutor = $event)"
              legend="Instrutor" placeholder="Digite o nome do instrutor" :disabled="loading" 
              data-testid="input-instrutor" />
          </div>
        </div>

        <div class="buttons">
          <Button type="button" @handle:click="clearInputs" text="Limpar" :fill="false" color="danger"
            :disabled="loading" data-testid="btn-limpar">
            <CloseCircleOutline :size="18" />
          </Button>

          <Button type="submit" text="Consultar" color="primary" :disabled="loading" data-testid="btn-consultar">
            <Magnify :size="18" />
          </Button>
        </div>
      </form>

      <div class="loading" v-if="loading">
        <LoadingSpinner />
      </div>

      <div v-else-if="aulas.length > 0 && !loading" class="table-container" data-testid="table-container">
        <Paginate :total-pages="paginationData.lastPage" :current-page="paginationData.currentPage"
          @page-changed="fetchAulas" data-testid="paginate-pendentes" />

        <Table :headers="['Autoescola', 'Aluno', 'Instrutor', 'Data da aula', 'Status', 'Tempos após o retorno']" 
          data-testid="table-pendentes-rejeitadas">
          <tr v-for="(aula, index) in aulas" :key="index" data-testid="row-aula">
            <td>{{ getFantasyName(aula.autoescola) }}</td>
            <td>{{ aula.aluno }}</td>
            <td>{{ aula.instrutor }}</td>
            <td>{{ aula.data_aula }}</td>
            <td>{{ aula.status }}</td>
            <td v-if="aula.data_registro !== 'Hoje'">{{ `${aula.data_registro} Dias` }}</td>
            <td v-else>{{ aula.data_registro }}</td>
          </tr>
        </Table>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from 'core/Modal'
import LoadingSpinner from 'core/LoadingSpinner'
import Select from 'core/Select'
import Period from 'core/Period'
import Input from 'core/Input'
import Button from 'core/Button'
import Table from 'core/Table'
import Paginate from 'core/Paginate'
import TrayArrowDown from 'icons/TrayArrowDown'
import CloseCircleOutline from 'icons/CloseCircleOutline'
import Magnify from 'icons/Magnify'
import _export from '../../../../services/export'

export default {
  name: 'PendentesERejeitadasModal',
  components: {
    Modal,
    LoadingSpinner,
    Select,
    Period,
    Input,
    Button,
    Table,
    Paginate,

    TrayArrowDown,
    CloseCircleOutline,
    Magnify,
  },
  data() {
    return {
      schema: '',
      initialDate: '',
      finalDate: '',
      aluno: '',
      instrutor: '',
      paginationData: {
        currentPage: 1,
        lastPage: 0,
        total: 0,
      },
      schemaOptions: [],
      aulas: [],
      loaded: false,
      loading: false,
    }
  },
  methods: {
    async open() {
      this.$refs.modal.open()

      await this.fetchCfcs()

      this.loaded = true
    },
    close() {
      this.$refs.modal.close()

      this.schema = ''
      this.initialDate = ''
      this.finalDate = ''
      this.aluno = ''
      this.instrutor = ''
      this.loaded = false
      this.loading = false
    },
    async fetchCfcs() {
      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/autoescola/todas`)
        .then((res) => {
          this.schemaOptions = res.body.dados
            .filter(cfc => cfc.nome_fantasia !== "TESTE")
            .map(cfc => ({
              value: cfc.tenant_schema,
              text: cfc.nome_fantasia
            }))
        })
        .catch((error) => {
          this.$toasted.show('Erro!' + error.body.mensagem, {
            position: 'top-right',
          })
        })
    },
    async handleSubmit() {
      if (this.validateInputs()) {
        await this.fetchAulas()
      }
    },
    validateInputs() {
      if (!this.schema) {
        this.$toasted.show('Selecione uma autoescola.', {
          icon: 'fa-times',
          position: 'top-right',
        })
        return false
      }

      if ((this.initialDate && !this.finalDate) || (!this.initialDate && this.finalDate)) {
        this.$toasted.show('Ambos os campos de período devem ser preenchidos.', {
          icon: 'fa-times',
          position: 'top-right',
        })
        return false
      }

      if (this.initialDate && this.finalDate) {
        const initial = new Date(this.initialDate)
        const final = new Date(this.finalDate)

        if (final < initial) {
          this.$toasted.show('A data final deve ser maior ou igual à data inicial!', {
            icon: 'fa-times',
            position: 'top-right',
          })
          return false
        }
      }

      return true
    },
    async fetchAulas(page = 1) {
      this.loading = true

      const params = {
        page,
        schema: this.schema,
      }

      if (this.aluno) params.aluno = this.aluno
      if (this.instrutor) params.instrutor = this.instrutor
      if (this.initialDate && this.finalDate) {
        params.periodoI = this.initialDate
        params.periodoF = this.finalDate
      }

      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/aulas/praticas/relatorio/pendentes-rejeitadas`, {
        params,
      })
        .then((res) => {
          const result = res.body.dados

          if (!result.data.length) {
            this.$toasted.show('Sem resultados para sua pesquisa.', {
              position: 'top-right',
            })
          }

          this.aulas = result.data

          this.paginationData = {
            currentPage: result.current_page,
            lastPage: result.last_page,
            total: result.total,
          }
        })
        .catch((err) => {
          this.$toasted.show(err.body.mensagem, {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearInputs() {
      this.schema = ''
      this.initialDate = ''
      this.finalDate = ''
      this.aluno = ''
      this.instrutor = ''
    },
    getFantasyName(schema) {
      return this.schemaOptions.find(cfc => cfc.value === schema).text
    },
    async handleExport() {
      if (!this.initialDate && !this.finalDate) {
        this.$toasted.show('Ambos os campos de período devem ser preenchidos.', {
          icon: 'fa-times',
          position: 'top-right',
        })

        return
      }

      if (this.initialDate && this.finalDate) {
        const initial = new Date(this.initialDate)
        const final = new Date(this.finalDate)

        if (final < initial) {
          this.$toasted.show('A data final deve ser maior ou igual à data inicial!', {
            icon: 'fa-times',
            position: 'top-right',
          })

          return
        }
      }

      this.loading = true

      const params = {
        dataInicial: this.initialDate,
        dataFinal: this.finalDate,
      }

      if (this.schema) params.schema = this.schema

      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/aulas/praticas/relatorio/pendentes`, {
        params,
      })
        .then((res) => {
          _export.downloadCSV(res.body.dados, 'praticas-pendentes')
        })
        .catch((err) => {
          this.$toasted.show(`Erro ao tentar gerar relatório: ${err.body.mensagem}`, {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
}

.actions {
  display: flex;
  justify-content: flex-end;
}

.relatorio-form {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;

  .inputs {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;

    .inputs-row {
      display: flex;
      flex-wrap: wrap;
      gap: 1.5rem;

      .input-full {
        flex: 1;
      }
    }
  }

  .buttons {
    align-self: flex-end;

    display: flex;
    gap: 0.5rem;
  }
}

.table-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .pagination-container {
    align-self: flex-end;
  }
}
</style>